export default {
  box: ({ isMobile }) => ({
    cursor: 'pointer',
    mb: isMobile ? '15px' : '25px',
    mt: isMobile ? '20px' : '20px',
    width: '100%',
    height: isMobile ? 80 : 120,
    borderRadius: '10px',
    bgcolor: 'background.paper',
    position: 'relative',
    '&:hover': {
      '& > div:first-of-type': {
        transform: 'translate(-50%, 0) scale(1.1)',
      },
    },
  }),
  title: ({ isMobile }) => ({
    height: 30,
    width: isMobile ? 120 : 170,
    position: 'absolute',
    left: '50%',
    bottom: '-10px',
    borderRadius: '10px',
    transform: 'translate(-50%, 0)',
    bgcolor: 'background.default',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  round: {
    width: '10px',
    height: '20px',
    position: 'absolute',
    top: 0,
    bgcolor: 'background.default',
    '& > em': {
      display: 'block',
      width: '100%',
      height: '100%',
      bgcolor: 'background.paper',
    },
  },
  image: ({ isMobile, image }) => ({
    transition: '0.3s',
    pointerEvents: 'none',
    top: isMobile ? '-25px' : '-50px',
    left: '50%',
    position: 'absolute',
    transform: 'translate(-50%, 0)',
    width: isMobile ? 130 : 265,
    height: isMobile ? 90 : 170,
    backgroundSize: 'contain', // to contain using real images
    backgroundPosition: 'bottom center',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${image})`,
  }),
};
